import React from 'react'

import Modal from '../../../../components/Modal'
import { IconCopyLink, IconDelete, IconDuplicate } from '../../../../svg'

export const MobileActionsModal = ({
    modal,
    t,
    actionLoading,
    openModal,
    closeModal,
    openShareModal,
    duplicateProject,
}) => {
    return (
        <Modal
            settings={{ overlayClose: true }}
            styles={{ padding: '40px 28px' }}
            data={{ open: modal.isOpen && modal.name === 'mobile_actions', maxWidth: 288 }}
            events={{ onCloseModal: closeModal }}
        >
            {modal.data && (
                <div className="projects-mobile-menu-modal">
                    <ul className="items">
                        {modal.data.projectStatus === 'PUBLISHED' && (
                            <li onClick={openShareModal(modal.data)}>
                                <span className="icon" data-icon="copyLink">
                                    <IconCopyLink />
                                </span>
                                {t('_common.copy_link')}
                            </li>
                        )}
                        <li
                            className={actionLoading.duplicateProject ? 'is-loading' : ''}
                            onClick={duplicateProject(modal.data)}
                        >
                            <span className="icon" data-icon="duplicate">
                                <IconDuplicate />
                            </span>
                            {t('_pages._my_projects.duplicate_project')}
                        </li>
                        <li onClick={openModal('delete_project', modal.data)}>
                            <span className="icon" data-icon="delete">
                                <IconDelete />
                            </span>
                            {t('_common.delete')}
                        </li>
                    </ul>
                </div>
            )}
        </Modal>
    )
}
